// Copyright ©️ 2026 eVolve MEP, LLC

import { type WorkOrder, useEvolveGet } from '@evolvemep/api-ts';
import { LoadingOverlay } from '@mantine/core';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import { isNil } from 'helpers/isNotNil';
import { FabricationItems } from 'modules/Shop/EvolveFabrication/FabricationItems';

type Props = {
  opened: boolean;
  onClose: () => void;
  workOrder: WorkOrder;
  onItemsChanged: () => void;
};

const FabricationItemsWrapped = ({ workOrder, onItemsChanged }: Pick<Props, 'workOrder' | 'onItemsChanged'>) => {
  const { data: project } = useEvolveGet(`shop/project/${workOrder.projectId}`, { lazy: false });
  if (isNil(project)) return <LoadingOverlay visible />;
  return (
    <FabricationItems
      addToWorkOrder={workOrder}
      onElementsUpdated={onItemsChanged}
      selectedProjects={[project]}
      selectedFacilities={[]}
    />
  );
};

export const AddFabricationItemsToWorkOrderModal = ({ opened, onClose, workOrder, onItemsChanged }: Props) => (
  <WrappedModal
    miniHeader={workOrder.name}
    title={workOrder.identifier}
    subtitle="Add fabrication items"
    opened={opened}
    hideModalButtons
    size="xxl"
    tall
    onClose={onClose}
  >
    <FabricationItemsWrapped workOrder={workOrder} onItemsChanged={onItemsChanged} />
  </WrappedModal>
);
